import { render, staticRenderFns } from "./SystemThemes.vue?vue&type=template&id=6dc52e36&scoped=true&"
import script from "./SystemThemes.vue?vue&type=script&lang=js&"
export * from "./SystemThemes.vue?vue&type=script&lang=js&"
import style0 from "./SystemThemes.vue?vue&type=style&index=0&id=6dc52e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc52e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc52e36')) {
      api.createRecord('6dc52e36', component.options)
    } else {
      api.reload('6dc52e36', component.options)
    }
    module.hot.accept("./SystemThemes.vue?vue&type=template&id=6dc52e36&scoped=true&", function () {
      api.rerender('6dc52e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemThemes.vue"
export default component.exports